import * as React from "react";
import { FormItem } from "../../../../components/antd/form/FormItem";
import { FormItemValue } from "../../../../components/antd/form/FormItemValue";
import { FormLabel } from "../../../../components/antd/form/FormLabel";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";

export const InitialCapacityReadonly: React.FC = () => {
  const initialCapacity = useCpFormValue(`initialCapacity`);

  return (
    <FormItem lastItem>
      <FormLabel>Initial Capacity</FormLabel>
      <FormItemValue>{initialCapacity} GB</FormItemValue>
    </FormItem>
  );
};
